const ViewingRoom = `
  id
  description
  inactive
`;

export default ViewingRoom;
